export const OEM_CONSTANTS = {
  // ADD_OEM
  ADD_OEM_REQUEST: "ADD_OEM_REQUEST",
  ADD_OEM_SUCCESS: "ADD_OEM_SUCCESS",
  ADD_OEM_FAILURE: "ADD_OEM_FAILURE",
  //   GET_OEM
  GET_OEM_REQUEST: "GET_OEM_REQUEST",
  GET_OEM_SUCCESS: "GET_OEM_SUCCESS",
  GET_OEM_FAILURE: "GET_OEM_FAILURE",
  //  EDIT_OEM
  EDIT_OEM_REQUEST: "EDIT_OEM_REQUEST",
  EDIT_OEM_SUCCESS: "EDIT_OEM_SUCCESS",
  EDIT_OEM_FAILURE: "EDIT_OEM_FAILURE",
  // DELETE_OEM
  DELETE_OEM_REQUEST: "DELETE_OEM_REQUEST",
  DELETE_OEM_SUCCESS: "DELETE_OEM_SUCCESS",
  DELETE_OEM_FAILURE: "DELETE_OEM_FAILURE",
  // OEM_STATUS
  CHANGE_OEM_STATUS_REQUEST: "CHANGE_OEM_STATUS_REQUEST",
  CHANGE_OEM_STATUS_SUCCESS: "CHANGE_OEM_STATUS_SUCCESS",
  // CHANGE_OEM_STATUS_FAILURE
  GET_SCAN_TYPES_REQUEST: "GET_SCAN_TYPES_REQUEST",
  GET_SCAN_TYPES_SUCCESS: "GET_SCAN_TYPES_SUCCESS",
  GET_SCAN_TYPES_FAILURE: "GET_SCAN_TYPES_FAILURE",
  // GET_OEM_NAMES
  GET_OEM_NAMES_REQUEST: "GET_OEM_NAMES_REQUEST",
  GET_OEM_NAMES_SUCCESS: "GET_OEM_NAMES_SUCCESS",
  GET_OEM_NAMES_FAILURE: "GET_OEM_NAMES_FAILURE",
  // GET_LICENSES
  GET_LICENSES_REQUEST: "GET_LICENSES_REQUEST",
  GET_LICENSES_SUCCESS: "GET_LICENSES_SUCCESS",
  GET_LICENSES_FAILURE: "GET_LICENSES_FAILURE",
  // GET_LICENSES_LIST
  GET_LICENSES_LIST_REQUEST: "GET_LICENSES_LIST_REQUEST",
  GET_LICENSES_LIST_SUCCESS: "GET_LICENSES_LIST_SUCCESS",
  GET_LICENSES_LIST_FAILURE: "GET_LICENSES_LIST_FAILURE",
  // GET_OEM_PARTNER_USERS
  GET_OEM_PARTNER_USERS_REQUEST: "GET_OEM_PARTNER_USERS_REQUEST",
  GET_OEM_PARTNER_USERS_SUCCESS: "GET_OEM_PARTNER_USERS_SUCCESS",
  GET_OEM_PARTNER_USERS_FAILURE: "GET_OEM_PARTNER_USERS_FAILURE",
  // CLEAR_OEM_SUCCESS
  CLEAR_OEM_SUCCESS: "CLEAR_OEM_SUCCESS",
};
